import { bdrSettlementCalendarsBlackoutDatesRequested } from 'state/settlementDateCalendars/settlementDateCalendars.action';
import type { Thunk } from 'state/state.common';

export function checkSettlementCalendarsUpdateRequestNeededThunk(currency: string): Thunk<void> {
  return (
    dispatch,
    getState,
    {
      selectors: {
        settlementDateCalendarsSelector: { isUnknownSettlementDateCalendar },
      },
    },
  ) => {
    if (currency) {
      if (isUnknownSettlementDateCalendar(getState(), currency)) {
        dispatch(bdrSettlementCalendarsBlackoutDatesRequested(currency));
      }
    }
  };
}
